var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticClass: "myTable lazy-table",
          staticStyle: { width: "900px" },
          attrs: {
            data: _vm.tableData,
            "max-height": "380",
            border: "",
            stripe: "",
            "row-key": "id",
          },
        },
        [
          _vm._t("default", function () {
            return [_vm._v(" 无数据 ")]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }